
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/progetti/[slug]",
      function () {
        return require("private-next-pages/progetti/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/progetti/[slug]"])
      });
    }
  